import EventEmitter from "eventemitter3";

export enum ListenerTypes {
  exitIntent = "exitIntent",
  scrollPercentage = "scrollPercentage",
  visibilityChange = "visibilityChange",
  urlChange = "urlChange",
}

export const listener = (() => {
  const Listeners: Record<string, EventEmitter<string | symbol, any>> = {};

  const get = (event: ListenerTypes) => {
    return Listeners[event];
  };

  const set = (event: ListenerTypes) => {
    if (!Listeners[event]) {
      const eventEmitter = new EventEmitter();
      Listeners[event] = eventEmitter;
    }
  };

  const emit = (event: ListenerTypes, payload?: any) => {
    const listener = get(event);

    if (listener) {
      listener.emit(event, payload);
    }
  };

  const on = (event: ListenerTypes, callback: any) => {
    const listener = get(event);

    if (listener) {
      listener.on(event, callback);
    }
  };

  return {
    set,
    get,
    on,
    emit,
  };
})();
